document.querySelectorAll('.receive-step-btn').forEach(button => {
    button.addEventListener('click', function() {
        document.querySelectorAll('.receive-step-btn').forEach(sibling => {
            sibling.classList.remove('active');
        });
        this.classList.add('active');
        const targetClass = this.getAttribute('data-target');
      console.log('clicked',targetClass);
        const targetElement = document.querySelector(`.${targetClass}`);

        document.querySelectorAll('.receive-step').forEach(sibling => {
            sibling.classList.remove('show-receive-step');
        });
        if (targetElement) {
            targetElement.classList.add('show-receive-step');
        }
    });
});
